import { render, staticRenderFns } from "./GerenciarPermissoesIcon.vue?vue&type=template&id=55b441f6"
import script from "./GerenciarPermissoesIcon.vue?vue&type=script&lang=js"
export * from "./GerenciarPermissoesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports